<template>
    <div :class="aspect.rowClass">
        <div :class="aspect.fieldColumnAThird+' mb-2'">
            <select :value="date|date" @input="e => set({date:parseInt(e.target.value)})" @change="e => set({date:parseInt(e.target.value)})" :class="aspect.formFieldClass" :disabled="disabled">
                <option disabled="disabled">{{translations.pickDay}}</option>
                <option v-for="d in daysInMonth" :key="'day'+d" :value="d">{{d}}</option>
            </select>
        </div>
        <div :class="aspect.fieldColumnAThird+' mb-2'">
            <select :value="date|month" @input="e => set({month:parseInt(e.target.value)})" @change="e => set({month:parseInt(e.target.value)})" :class="aspect.formFieldClass" :disabled="disabled">
                <option disabled="disabled">{{translations.pickMonth}}</option>
                <option v-for="m in 12" :key="'month'+m" :value="m-1">{{ m-1|monthName }}</option>
            </select>
        </div>
        <div :class="aspect.fieldColumnAThird">
            <select :class="aspect.formFieldClass" ref="selectYear" :value="date|year" @input="e => set({year:parseInt(e.target.value)})" @change="e => set({year:parseInt(e.target.value)})" :disabled="disabled">
                <option disabled="disabled">{{translations.pickYear}}</option>
                <option v-for="y in years" :key="'year'+y" :value="startingYear-(y-1)">{{startingYear-(y-1)}}</option>
            </select>
        </div>
    </div>
</template>

<script>
    let moment = require('moment');
    moment.locale('it');
    export default {
        name: "form-element-date",
        props: {
            value:{type:String},
            startingYear:{type:Number, default: (new Date()).getFullYear()},
            years:{type:Number,default:100},
            format:{type:String,default:moment.ISO_8601},
            translations: {type: Object},
            aspect: {type: Object, default: function(){ return {}; }},
            disabled:{type: Boolean, default: false}
        },
        data(){
            let date = moment(this.value);
            if(!date.isValid()){ date=moment(); }
            return {
                date,
                timestamp:date.format('x'),
                index: 0
            }
        },
        computed:{
            daysInMonth(){
                return this.date.daysInMonth();
            }
        },
        watch:{
            value(){
                let date = moment(this.value);
                if(!date.isValid()){
                    date=moment();
                }
                this.date=date;
            }
        },
        methods: {
            set(v){
                this.date.set(v);
                this.date = this.date.clone();//<=== Responsive fix
                let d = this.date.format(this.format);
                this.$emit('input',d);
            },
            async evaluateValidationCondition(condition){
                if(condition.type && condition.type=='adult'){
                    if(moment(new Date()).diff(this.date, "years") < 18){
                        return this.translations.adultWarning;
                    }
                }
                return null;                
            }
        },
        mounted(){
            let d = this.date.format(this.format);
            this.$emit('input',d);
        },
        filters:{
            monthName(v){
                return moment({month:v}).format('MMMM');
            },
            year(v){return v.year();},
            month(v){return v.month();},
            date(v){return v.date();}
        }
    }
</script>

